import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Opportunity } from "../opportunity/entity";
import { Population } from "../population";

import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import { type OpportunityPopulation } from "./entity";

export const OpportunityPopulationEntityConfig: HyperEntityConfig<OpportunityPopulation> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: Allow.authenticated,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      opportunity: {
        $is: await copyApiPrefilterPerRole(Opportunity),
      },
    });

    filter(Roles.All, {
      population: {
        $is: await copyApiPrefilterPerRole(Population),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Opportunity, {
        id: entity.opportunityId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      opportunity: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },

  id: {
    opportunityId: true,
    populationId: true,
  },
};






